/**
 * The words for "the place the data comes from", in copy every city shows.
 *
 * "PTV" is Melbourne's name for its source and nobody else's: a Sydney reader
 * is told TfNSW could not be reached, a Brisbane one Translink. Each city
 * carries its own short name as `sourceShort` (see src/city.js), and the
 * sentences that name it live here so that a page cannot hard-code the one
 * city's. A FUNCTION each, because the city can change under a screen.
 */
import { city } from './city.js';

/** The city's short name for its data source: PTV, TfNSW, Translink… */
export const sourceShort = () => city().sourceShort;

/** "Couldn’t reach PTV", as a heading or a stamp's first words. */
export const couldntReach = (mode = null) => `Couldn’t reach ${mode?.sourceShort ?? sourceShort()}`;

/** The heading's sentence, with what to do about it. */
export const couldntReachLine = () => `${couldntReach()}. Pull down to try again.`;

/** "PTV has no station called Foo." */
export const noStationCalled = (name) => `${sourceShort()} has no station called ${name}.`;

/**
 * Where a MODE's live data comes from, for copy. A mode may carry its own
 * `sourceShort` (Melbourne's trams run on Transport Victoria's GTFS feed, not
 * PTV's); otherwise it is the city's.
 */
export const modeSource = (mode) => mode?.sourceShort ?? sourceShort();
